module.exports = __webpack_public_path__ + "static/media/background.f57217e6.png";